/* eslint-disable max-len */
import React from 'react';
import { PlusCircle } from 'react-feather';

import EmptyState from 'src/components/EmptyState';
import ActionButton from 'src/components/ActionButton';
import HttpLedger from 'src/components/HttpLedger';
import Ledger from 'src/components/Ledger';
import useModal from 'src/components/Modal/useModal';
import UserCell from 'src/components/cells/UserCell';

import ContactModal from './ContactModal';

function ContactsLedger() {
  const {
    isOpen, openModal, closeModal
  } = useModal();

  const columns = [
    {
      title: 'Title',
      cellContent: (contact: any) => <UserCell accounts={[contact.account]} />,
      width: '100%',
    },
  ];

  const actions = (
    <ActionButton
      icon={<PlusCircle />}
      onClick={() => openModal()}
      look="primary"
    >
      New contact
    </ActionButton>
  );

  return (
    <HttpLedger
      url="/automatic/contacts/"
      actions={actions}
      columns={columns}
      emptyState={<EmptyState />}
      isPaginated
      isSearchable
      render={({
        fetchData,
        ...ledgerProps
      }: any) => (
        <>
          {
            isOpen && (
              <ContactModal
                onClose={closeModal}
                fetchData={fetchData}
              />
            )
          }
          <Ledger {...ledgerProps} />
        </>
      )}
    />
  );
}

export default ContactsLedger;
